import React, { type ComponentProps, memo, useState } from 'react';

import { SvgDotsHorizontalTriple } from '../../icons/v1/DotsHorizontalTriple';
import { theme, styles } from '../../style';
import { Button } from '../common/Button';
import { Menu } from '../common/Menu';
import { View } from '../common/View';
import { Tooltip } from '../tooltips';

interface ICategoryHeaderCellProps {
  toggleHiddenCategories: () => void;
  expandAllCategories: () => void;
  collapseAllCategories: () => void;
}

export default function CategoryHeaderCell({
  toggleHiddenCategories,
  expandAllCategories,
  collapseAllCategories,
}: ICategoryHeaderCellProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <View
      style={{
        width: 200,
        color: theme.pageTextLight,
        justifyContent: 'center',
        paddingLeft: 15,
        paddingRight: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        userSelect: 'none',
        WebkitUserSelect: 'none',
      }}
    >
      <View style={{ flexGrow: '1' }}>Category</View>
      <Button
        type="bare"
        aria-label="Menu"
        onClick={() => {
          setMenuOpen(true);
        }}
        style={{ color: 'currentColor', padding: 3 }}
      >
        <SvgDotsHorizontalTriple
          width={15}
          height={15}
          style={{ color: theme.pageTextLight }}
        />
        {menuOpen && (
          <Tooltip
            position="bottom-right"
            width={200}
            style={{ padding: 0 }}
            onClose={() => {
              setMenuOpen(false);
            }}
          >
            <Menu
              onMenuSelect={type => {
                if (type === 'toggle-visibility') {
                  toggleHiddenCategories();
                } else if (type === 'expandAllCategories') {
                  expandAllCategories();
                } else if (type === 'collapseAllCategories') {
                  collapseAllCategories();
                }
                setMenuOpen(false);
              }}
              items={[
                {
                  name: 'toggle-visibility',
                  text: 'Toggle hidden categories',
                },
                {
                  name: 'expandAllCategories',
                  text: 'Expand all',
                },
                {
                  name: 'collapseAllCategories',
                  text: 'Collapse all',
                },
              ]}
            />
          </Tooltip>
        )}
      </Button>
    </View>
  );
}
